import { render, staticRenderFns } from "./showImg.vue?vue&type=template&id=3cc14699&"
import script from "./showImg.vue?vue&type=script&lang=js&"
export * from "./showImg.vue?vue&type=script&lang=js&"
import style0 from "./showImg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports